/* eslint-disable */ // @ts-nocheck
// These types are used to read in json formats.
// Pull out all keys (included nested keys)
// Then convert them into a type that we can use in our codebase
// ignores all value entries that are arrays
// for type safety there is one that pulls out array keys, object keys and string key seprately
// https://dev.to/pffigueiredo/typescript-utility-keyof-nested-object-2pa3
export function loopNestedStrings(object, operation, keysToSkip = [], previousKey = '') {
    for (const [key, value] of Object.entries(object)){
        if (keysToSkip.includes(key)) continue;
        const fullKey = previousKey == '' ? `strings:${key}` : `${previousKey}.${key}`;
        if (Array.isArray(value)) {
            operation(value, fullKey);
            continue;
        }
        switch(typeof value){
            case 'object':
                loopNestedStrings(value, operation, keysToSkip, fullKey);
                break;
            case 'string':
                operation(value, fullKey);
                break;
            default:
                throw new Error('Failed to evalute string | type: ${typeof value} | value: ${JSON.stringify(value)}');
        }
    }
}
